// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Navbar from "src/components/shared/navigation/Navbar/Navbar";

// Styles
import { PageContainerWrapper } from "src/styles/mui/muiStylesHelper";

// Contexts
import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

const NotFound = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { allClinicInfo } = useClinicContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar canNavigate={allClinicInfo?.length > 0} />
      <Box sx={PageContainerWrapper(theme)}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          py={10}
          px="24px"
        >
          <Typography fontSize="24px" fontWeight={600}>
            404 {t("Page Not Found")}!
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFound;
